// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
// Real component declaration, not a reference copy — see hooks/useAuth.ts.
import * as _module from "@livingsyncs/ui";

export function FullPageLoader() {
  return <_module.FullPageLoader />;
}
